'use strict';

var d3 = require('d3');
var SnapshotDatesChart = function SnapshotDatesChart(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartXAxis, chartYAxis, chartConstants, svgPatternService, chartParams, chartScales, mapService, chartTodayLine) {
  var MAX_RANGE_SIZE = 30;
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    svgPatternService.initPatterns(['user-exclusion', 'user-exclusion-viewport']);
    var dispatch = d3.dispatch('selectSnapshotDate');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups(mapService.getMapComponent('group'), formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars(mapService.getMapComponent('m1Bar'));
    var circles = chartCircles(mapService.getMapComponent('circles'));
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withoutLine();
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    var yAxisRight = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT);
    var todayLine = chartTodayLine();
    yAxisLeft.label(mapService.getMapComponent('yLeftLabel'));
    yAxisRight.label(mapService.getMapComponent('yRightLabel'));
    yAxisRight.withLabelRotation(-90);
    this.maxRangeSize = MAX_RANGE_SIZE;
    this.render = function (data, range) {
      this.initChart(data, this.getMaxRange(range), chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange, mapService.getMapComponent('scaleMetric'));
      this.secondaryScale = chartScales(this.params, this.data, this.visibleXRange, mapService.getMapComponent('secondaryScaleMetric'), mapService.getMapComponent('complementarySecondaryScaleMetric'));
      this.callForDataGroup([yAxisRight, todayLine, groups, m1Bars, xAxis], this.scales);
      this.callForDataGroup([yAxisLeft, circles], this.secondaryScale);
    };
    this.changeMetrics = function () {
      yAxisRight.label(mapService.getMapComponent('yRightLabel'));
      return this;
    };
    groups.on('groupclick', function (d) {
      dispatch.selectSnapshotDate(d);
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  Chart.prototype.domainChange = function (range) {
    this.render(this.data, range);
  };
  Chart.prototype.getMaxRange = function (range) {
    if (typeof range === 'undefined') {
      return range;
    }
    var delta = range[1] - range[0];
    if (delta > MAX_RANGE_SIZE) {
      range[1] = range[0] + MAX_RANGE_SIZE;
    }
    return range;
  };
  return Chart;
};
SnapshotDatesChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'SvgPatternService', 'SnapshotDatesChartParams', 'SnapshotDatesChartScales', 'SnapshotDatesMapDataToChartComponentsService', 'SnapshotDatesChartTodayLine'];
module.exports = SnapshotDatesChart;